<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名称" :value="2"></el-option>
                            <el-option label="合同编号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制审核状态" :value="0"></el-option>
                        <el-option label="仅看已通过的" :value="1"></el-option>
                        <el-option label="仅看已过期的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示最近更新的" :value="1"></el-option>
                        <el-option label="优先展示合同最早到期的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.queryTimeType" slot="prepend" placeholder="请选择">
                                <el-option label="合同到期时间" :value="1"></el-option>
                                <el-option label="最近更新时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/goods/receivables/createOrUpdateReceivablesInfo')" class="page-btns-box">
            <el-button  type="primary" icon="el-icon-plus" size="small" @click="add">新增</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="status" label="审核状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" class="color-success">已通过</span>
                        <span v-else>已过期</span>
                    </template>
                </el-table-column>
                <el-table-column prop="contractSn" label="合同编号" min-width="100"></el-table-column>
                <el-table-column prop="userType" label="用户身份">
                    <template slot-scope="scope">{{$userType.get(scope.row.userType)}}</template>
                </el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="name" label="用户名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateTime" label="最近更新时间" min-width="150"></el-table-column>
                <el-table-column prop="contractExpireTime" label="合同到期时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/goods/receivables/getInfoDetail')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
const defaultParams = {
    pageNo: 1,
    queryType: 1,
    queryValue: '',
    queryTimeType: 1,
    startTime: null,
    endTime: null,
    status: 0,
    sort: 1,
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                queryType: parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue || '',
                queryTimeType:  parseInt(this.$route.query.queryTimeType || 1),
                startTime: this.$route.query.startTime || null,
                endTime: this.$route.query.endTime || null,
                status: parseInt(this.$route.query.status || 0),
                sort: parseInt(this.$route.query.sort || 1),
            },
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            listLoading: true,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || null,
                endTime:this.datetimerange && this.datetimerange[1] || null
            }
            this.$request({
                url: "/goods/receivables/getInfoPageList",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //编辑事件
        add(){
            this.$router.push('/finance/goods/receivables/manage/add');
        },
        edit(id) {
            this.$router.push({
                path: `/finance/goods/receivables/manage/edit/${id}`,
                query: {
                    v: this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
    }
}
</script>
